'use strict';

import divisionPolitica from './invu_libs/divisionPolitica.js';
import validators from './invu_libs/validators.js';
import createCustomElement from './invu_libs/DOMcreators.js';

var _dp, _validators;
const alloc_init = () => {
    let _cs;
    if(document.body.dataset.step != undefined) {
        _cs = parseInt(document.body.dataset.step);
    } else {
        _cs = 1;
    }
    
    switch(_cs) {
        case 2:
            break;
        default:
            inHome();
            break;
    }
};
const inHome = (e) => {
    _dp = divisionPolitica();
    _validators = validators();
    let _p_ini = document.getElementById('p_txt');
    for(let i = 0; i < _dp.provincias.length; i++) {
        _p_ini.appendChild(
            createCustomElement(
                'option',
                {'value': _dp.provincias[i].title},
                [_dp.provincias[i].title]
            )
        );
    }
    changeSelects();
    document.getElementById('main_form').addEventListener('submit',validateForm, !1);
    document.getElementById('p_txt').addEventListener('change', changeSelects, !1);
    document.getElementById('c_txt').addEventListener('change', changeSelects, !1);
};
const changeSelects = (e) => {

    let _i = document.getElementById('p_txt');
    let _c = _dp.provincias[_i.selectedIndex].cantones;
    let _d;
    let _canton = document.getElementById('c_txt');
    let _distrito = document.getElementById('d_txt');

    if(e == undefined || e.currentTarget == document.getElementById('p_txt')) {
        _canton.options.length = 0;
        for(let i = 0; i < _c.length; i++) {
            _canton.appendChild(
                createCustomElement(
                    'option',
                    {'value': _c[i].title},
                    [_c[i].title]
                )
            );
        }
    }

    _d = _dp.provincias[_i.selectedIndex].cantones[_canton.selectedIndex].distritos;

    _distrito.options.length = 0;
    for(let i = 0; i < _d.length; i++) {
        _distrito.appendChild(
            createCustomElement(
                'option',
                {'value': _d[i].title},
                [_d[i].title]
            )
        );
    }
};
const validateForm = (e) => {
    let _m = new Array();

    if( document.getElementById('name_txt').value.length == 0 ) {
        _m.push( createCustomElement('li',{},['El nombre es requerido']) );
    }
    if( document.getElementById('docid_txt').value.length < 9 ) {
        _m.push( createCustomElement('li',{},['La cédula es requerida']) );
    }

    if( _m.length != 0 ) {
        e.preventDefault();
        appendModal( createCustomElement('ul',{},_m), 'Atención' );
    }
};
const appendModal = (modalTxt = '', modalTittle, modalFooter) => {
	let modCont = new Array();
	if(modalTittle != undefined) {
		modCont.push( createCustomElement('div',{'class':'modal_header'},[ createCustomElement('h3',{},[modalTittle]) ]) );
	}
	modCont.push( createCustomElement('div',{'class':'modal_body'},[modalTxt]) );
	if(modalFooter != undefined) {
		modCont.push( createCustomElement('div',{'class':'modal_footer'},[modalFooter]) );
	}
	modCont.push( createCustomElement('a',{'href':'#','class':'modal_close'},['×']) );
	let mdl = createCustomElement('div',{'class':'modalAll'},modCont);
	let blk = createCustomElement('div',{'id':'modalDialog'},[mdl]);
	blk.addEventListener('click', e => {
		if(e.target === blk) {
			removeModal();
		}
	});
	document.body.appendChild(blk);
	document.querySelector('.modal_close').addEventListener('click',removeModal);
}
const removeModal = (eRM) => {
	if(eRM) {
		eRM.preventDefault();
	}
	document.body.removeChild(document.getElementById('modalDialog'));
}
document.addEventListener('DOMContentLoaded', alloc_init, !1);